"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReducer;
/**
 * create a reducer with function map.
 *
 * @param  {any} initialState  initial state value.
 * @param  {Object} handlers   function handlers as map.
 * @return {any}               next state value.
 */

function createReducer(initialState, handlers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];
    var reduceFn = handlers[action.type];
    return reduceFn ? reduceFn(state, action) : state;
  };
}